import { Component, input, InputSignal } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-pill',
  templateUrl: './configuration-pill.component.html',
  styleUrls: ['./configuration-pill.component.scss'],
  standalone: false,
})
export class ConfigurationPillComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly tooltip?: InputSignal<string> = input<string>();
  readonly templateType: InputSignal<'language' | 'configuration' | 'pack' | 'route'> = input<
    'language' | 'configuration' | 'pack' | 'route'
  >();
}
